import { IToggleCreate } from '../../../actions/bookingCalendar/reservationModal/toggleConfigurationModal'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IToggleCreate,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      configModal: {
        open: action.showModal,
      },
    },
  }
}
